/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { OptionVault } from '../OptionVault'

export class OptionVault__factory extends ContractFactory {
  constructor(
    linkLibraryAddresses: OptionVaultLibraryAddresses,
    signer?: Signer
  ) {
    super(_abi, OptionVault__factory.linkBytecode(linkLibraryAddresses), signer)
  }

  static linkBytecode(
    linkLibraryAddresses: OptionVaultLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$03106d4e1898139463e4ca6f62fde1e69e\\$__', 'g'),
      linkLibraryAddresses['__$03106d4e1898139463e4ca6f62fde1e69e$__']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    _uri: string,
    _aggregator: string,
    _collateral: string,
    _underlying: string,
    _priceOracle: string,
    _operator: string,
    _lendingPool: string,
    overrides?: Overrides
  ): Promise<OptionVault> {
    return super.deploy(
      _uri,
      _aggregator,
      _collateral,
      _underlying,
      _priceOracle,
      _operator,
      _lendingPool,
      overrides || {}
    ) as Promise<OptionVault>
  }
  getDeployTransaction(
    _uri: string,
    _aggregator: string,
    _collateral: string,
    _underlying: string,
    _priceOracle: string,
    _operator: string,
    _lendingPool: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _uri,
      _aggregator,
      _collateral,
      _underlying,
      _priceOracle,
      _operator,
      _lendingPool,
      overrides || {}
    )
  }
  attach(address: string): OptionVault {
    return super.attach(address) as OptionVault
  }
  connect(signer: Signer): OptionVault__factory {
    return super.connect(signer) as OptionVault__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OptionVault {
    return new Contract(address, _abi, signerOrProvider) as OptionVault
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: '_uri',
        type: 'string'
      },
      {
        internalType: 'address',
        name: '_aggregator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_collateral',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_underlying',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_priceOracle',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_lendingPool',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'AccountCreated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'profit',
        type: 'uint128'
      }
    ],
    name: 'Claimed',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'expiryId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint64',
        name: 'expiry',
        type: 'uint64'
      }
    ],
    name: 'ExpiryCreated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint32',
        name: 'tickId',
        type: 'uint32'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'tickDelta',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'hedgePosition',
        type: 'int256'
      }
    ],
    name: 'Hedged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      }
    ],
    name: 'Liquidated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'expiryId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'strike',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isPut',
        type: 'bool'
      }
    ],
    name: 'SeriesCreated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'profit',
        type: 'uint128'
      }
    ],
    name: 'Settled',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      }
    ],
    name: 'TransferBatch',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'TransferSingle',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'URI',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'holder',
        type: 'address'
      }
    ],
    name: 'Unlocked',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'expiryId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      }
    ],
    name: 'VaultDeposited',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'expiryId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      }
    ],
    name: 'VaultWithdrawn',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'accountId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'recepient',
        type: 'address'
      }
    ],
    name: 'Written',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      }
    ],
    name: 'addLong',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_accountId',
        type: 'uint32'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_underlyingAmount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_collateralAmount',
        type: 'uint256'
      }
    ],
    name: 'addUnderlyingLong',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_accountId',
        type: 'uint32'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_underlyingAmount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_collateralAmount',
        type: 'uint256'
      }
    ],
    name: 'addUnderlyingShort',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      }
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_amount',
        type: 'int128'
      },
      {
        internalType: 'enum IOptionVault.MarginLevel',
        name: '_marginLevel',
        type: 'uint8'
      }
    ],
    name: 'calRequiredMarginForASeries',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'calculateVaultDelta',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_size',
        type: 'uint128'
      }
    ],
    name: 'claim',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_cRatio',
        type: 'uint128'
      }
    ],
    name: 'closeShortPosition',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'createAccount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint64',
        name: '_expiry',
        type: 'uint64'
      },
      {
        internalType: 'uint64[]',
        name: '_strikes',
        type: 'uint64[]'
      },
      {
        internalType: 'uint64[]',
        name: '_ivs',
        type: 'uint64[]'
      }
    ],
    name: 'createExpiry',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      }
    ],
    name: 'decreaseDebt',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_collateral',
        type: 'uint128'
      }
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_cRatio',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      },
      {
        internalType: 'address',
        name: '_recepient',
        type: 'address'
      }
    ],
    name: 'depositAndWrite',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      }
    ],
    name: 'getAccount',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'owner',
            type: 'address'
          },
          {
            internalType: 'uint256',
            name: 'settledCount',
            type: 'uint256'
          }
        ],
        internalType: 'struct IOptionVault.AccountView',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      }
    ],
    name: 'getCollateralValueQuote',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint8',
        name: '_key',
        type: 'uint8'
      }
    ],
    name: 'getConfig',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'getExpiration',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'expiryId',
            type: 'uint128'
          },
          {
            internalType: 'uint64',
            name: 'expiry',
            type: 'uint64'
          },
          {
            internalType: 'uint256[]',
            name: 'seriesIds',
            type: 'uint256[]'
          }
        ],
        internalType: 'struct IOptionVault.Expiration',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getLastExpiry',
    outputs: [
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      }
    ],
    name: 'getLiquidatableAmount',
    outputs: [
      {
        internalType: 'uint128',
        name: 'limit',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getLiveOptionSerieses',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'expiryId',
            type: 'uint128'
          },
          {
            internalType: 'uint64',
            name: 'expiry',
            type: 'uint64'
          },
          {
            internalType: 'uint256[]',
            name: 'seriesIds',
            type: 'uint256[]'
          }
        ],
        internalType: 'struct IOptionVault.Expiration[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      }
    ],
    name: 'getOptionSeries',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'expiryId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'seriesId',
            type: 'uint256'
          },
          {
            internalType: 'uint64',
            name: 'expiry',
            type: 'uint64'
          },
          {
            internalType: 'uint64',
            name: 'maturity',
            type: 'uint64'
          },
          {
            internalType: 'uint128',
            name: 'strike',
            type: 'uint128'
          },
          {
            internalType: 'bool',
            name: 'isPut',
            type: 'bool'
          },
          {
            internalType: 'uint64',
            name: 'iv',
            type: 'uint64'
          }
        ],
        internalType: 'struct IOptionVault.OptionSeriesView',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      }
    ],
    name: 'getPositionSize',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'enum IOptionVault.MarginLevel',
        name: '_marginLevel',
        type: 'uint8'
      }
    ],
    name: 'getRequiredMargin',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'getTotalPayout',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'getVault',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'owner',
            type: 'address'
          },
          {
            internalType: 'bool',
            name: 'isSettled',
            type: 'bool'
          },
          {
            internalType: 'uint128',
            name: 'collateral',
            type: 'uint128'
          },
          {
            internalType: 'int256',
            name: 'hedgePosition',
            type: 'int256'
          },
          {
            internalType: 'uint128',
            name: 'shortLiquidity',
            type: 'uint128'
          }
        ],
        internalType: 'struct IOptionVault.VaultView',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      }
    ],
    name: 'liquidate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_cRatio',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_minFee',
        type: 'uint128'
      }
    ],
    name: 'makeShortPosition',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'onERC1155BatchReceived',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'onERC1155Received',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'optionInfo',
    outputs: [
      {
        internalType: 'address',
        name: 'aggregator',
        type: 'address'
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'collateral',
            type: 'address'
          },
          {
            internalType: 'address',
            name: 'underlying',
            type: 'address'
          }
        ],
        internalType: 'struct OptionLib.TokenContracts',
        name: 'tokens',
        type: 'tuple'
      },
      {
        internalType: 'uint128',
        name: 'seriesCount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'expiryCount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'expiredCount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'excessDebt',
        type: 'uint128'
      },
      {
        internalType: 'uint256',
        name: 'vaultCount',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: 'totalDepositedToLendingPool',
        type: 'uint128'
      },
      {
        internalType: 'contract LendingPool',
        name: 'lendingPool',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_repayAmount',
        type: 'uint128'
      }
    ],
    name: 'redeemCollateralFromLendingPool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      }
    ],
    name: 'removeLong',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_ammAddress',
        type: 'address'
      }
    ],
    name: 'setAMMAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint8',
        name: '_key',
        type: 'uint8'
      },
      {
        internalType: 'uint128',
        name: '_value',
        type: 'uint128'
      }
    ],
    name: 'setConfig',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_iv',
        type: 'uint128'
      }
    ],
    name: 'setIV',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      }
    ],
    name: 'setNewOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'settleVault',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_collateral',
        type: 'uint128'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      },
      {
        internalType: 'address',
        name: '_recepient',
        type: 'address'
      }
    ],
    name: 'write',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '0x60806040523480156200001157600080fd5b50604051620059d7380380620059d78339810160408190526200003491620001e2565b86620000408162000106565b50600580546001600160a01b03199081166001600160a01b03898116919091178355601280548316878316179055600380549092168582161790915560405163ee9b608f60e01b81526004810192909252868116602483015285811660448301528216606482015273__$03106d4e1898139463e4ca6f62fde1e69e$__9063ee9b608f9060840160006040518083038186803b158015620000e057600080fd5b505af4158015620000f5573d6000803e3d6000fd5b50505050505050505050506200037d565b80516200011b9060029060208401906200011f565b5050565b8280546200012d906200032a565b90600052602060002090601f0160209004810192826200015157600085556200019c565b82601f106200016c57805160ff19168380011785556200019c565b828001600101855582156200019c579182015b828111156200019c5782518255916020019190600101906200017f565b50620001aa929150620001ae565b5090565b5b80821115620001aa5760008155600101620001af565b80516001600160a01b0381168114620001dd57600080fd5b919050565b600080600080600080600060e0888a031215620001fd578283fd5b87516001600160401b038082111562000214578485fd5b818a0191508a601f83011262000228578485fd5b8151818111156200023d576200023d62000367565b604051601f8201601f19908116603f0116810190838211818310171562000268576200026862000367565b81604052828152602093508d8484870101111562000284578788fd5b8791505b82821015620002a7578482018401518183018501529083019062000288565b82821115620002b857878484830101525b9a50620002ca9150508a8201620001c5565b97505050620002dc60408901620001c5565b9450620002ec60608901620001c5565b9350620002fc60808901620001c5565b92506200030c60a08901620001c5565b91506200031c60c08901620001c5565b905092959891949750929550565b6002810460018216806200033f57607f821691505b602082108114156200036157634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052604160045260246000fd5b61564a806200038d6000396000f3fe608060405234801561001057600080fd5b50600436106102895760003560e01c8063a05b775f1161015c578063ce88b145116100ce578063e985e9c511610087578063e985e9c5146108d6578063f23a6e61146108e9578063f242432a14610921578063f66f9dcb14610934578063f8ef875914610947578063ff08603d1461095a57610289565b8063ce88b145146107fe578063d47427f914610877578063da3d576a1461088a578063ddef32621461089d578063df5c45ca146108b0578063e0a14dfe146108c357610289565b8063a9ea61b611610120578063a9ea61b61461074e578063aa4bf51714610761578063ab5d419a14610774578063bc197c8114610787578063bfeab6cc146107d8578063c9ad7350146107eb57610289565b8063a05b775f14610670578063a22cb46514610690578063a40402ed146106a3578063a599afb4146106b6578063a6466a761461073b57610289565b80632eb2c2d611610200578063708cf50e116101b9578063708cf50e146105da578063771e5673146105ef57806393949b101461060f57806395fa44a0146106225780639d682ab1146106355780639dca362f1461066857610289565b80632eb2c2d61461055b5780633c3a9a661461056e5780633ccb48dd14610581578063445a62b514610594578063449e9029146105a75780634e1273f4146105ba57610289565b8063186bb6c811610252578063186bb6c81461033557806324baee771461034a57806325e57ef41461035d5780632844e1e0146103705780632b15d997146104445780632b2ea46d1461054857610289565b8062fdd58e1461028e57806301ffc9a7146102b457806303712a84146102d75780630dfd106c146103025780630e89341c14610315575b600080fd5b6102a161029c366004614778565b610986565b6040519081526020015b60405180910390f35b6102c76102c23660046149ec565b610a1d565b60405190151581526020016102ab565b6102ea6102e5366004614bfb565b610a71565b6040516001600160801b0390911681526020016102ab565b6102ea610310366004614bfb565b610b0f565b610328610323366004614b35565b610e17565b6040516102ab919061516c565b610348610343366004614ca2565b610eab565b005b6102ea610358366004614c3f565b6110af565b61034861036b366004614bb3565b611156565b600554604080518082019091526006546001600160a01b03908116825260075481166020830152600854600954600c54600d54600e546011546103d498871697966001600160801b0380881697600160801b90048116968116958116949316911689565b604080516001600160a01b039a8b16815289518b16602080830191909152909901518a16908901526001600160801b039687166060890152948616608088015292851660a087015290841660c086015260e0850152909116610100830152909116610120820152610140016102ab565b6104f3610452366004614bfb565b6040805160a081018252600080825260208201819052918101829052606081018290526080810191909152506000828152600f60208181526040808420948452600285018252808420815160a0810183529690945291815292546001600160a01b03168452815460ff1615159284019290925260038101546001600160801b0390811692840192909252600481015460608401526005015416608082015290565b6040805182516001600160a01b03168152602080840151151590820152828201516001600160801b0390811692820192909252606080840151908201526080928301519091169181019190915260a0016102ab565b610348610556366004614d87565b611213565b61034861056936600461463c565b611359565b6102ea61057c366004614ceb565b611618565b61034861058f366004614c6a565b611a31565b6103486105a2366004614c6a565b611c3e565b6102ea6105b5366004614b35565b611e9c565b6105cd6105c83660046147a3565b611f48565b6040516102ab9190615134565b6105e26120a9565b6040516102ab91906150d4565b6105f7612139565b6040516001600160401b0390911681526020016102ab565b61034861061d366004614dd7565b61218f565b6102ea610630366004614d29565b6123a2565b610648610643366004614bfb565b612728565b604080516001600160801b039384168152929091166020830152016102ab565b6102a16127c8565b61068361067e366004614b35565b612893565b6040516102ab91906152c6565b61034861069e36600461474b565b612946565b6103486106b1366004614e0c565b612a2a565b6106c96106c4366004614b35565b612c09565b6040516102ab9190600060e082019050825182526020830151602083015260408301516001600160401b0380821660408501528060608601511660608501526001600160801b03608086015116608085015260a0850151151560a08501528060c08601511660c0850152505092915050565b6103486107493660046145cc565b612cc8565b61034861075c366004614dd7565b612d0e565b6102ea61076f366004614b71565b612ebb565b6102ea610782366004614bb3565b612f71565b6107bf61079536600461463c565b7fbc197c819b3e337a6f9652dd10becd7eef83032af3b9d958d3d42f669414662195945050505050565b6040516001600160e01b031990911681526020016102ab565b6103486107e6366004614acf565b61315b565b6103486107f9366004614e4e565b6132b4565b61085361080c366004614b35565b6040805180820190915260008082526020820152506000908152600f6020908152604091829020825180840190935280546001600160a01b03168352600101549082015290565b6040805182516001600160a01b0316815260209283015192810192909252016102ab565b610348610885366004614c6a565b613481565b610348610898366004614acf565b6136ed565b6102a16108ab366004614bfb565b6137b8565b6103486108be366004614e0c565b61384f565b6102ea6108d1366004614bfb565b61398a565b6102c76108e4366004614604565b6139f8565b6107bf6108f73660046146e5565b7ff23a6e612e1ff4830e658fe43f4e3cb4a5f8170bd5d9e69fb5d7a7fa9e4fdf9795945050505050565b61034861092f3660046146e5565b613a53565b610348610942366004614eda565b613bfc565b6103486109553660046145cc565b613c8c565b6102ea610968366004614ec0565b60ff166000908152601060205260409020546001600160801b031690565b60006001600160a01b0383166109f75760405162461bcd60e51b815260206004820152602b60248201527f455243313135353a2062616c616e636520717565727920666f7220746865207a60448201526a65726f206164647265737360a81b60648201526084015b60405180910390fd5b506000908152602081815260408083206001600160a01b03949094168352929052205490565b60006001600160e01b03198216636cdb3d1360e11b1480610a4e57506001600160e01b031982166303a24d0760e21b145b80610a6957506301ffc9a760e01b6001600160e01b03198316145b90505b919050565b600073__$03106d4e1898139463e4ca6f62fde1e69e$__630397ec3d60058585610a99613cd8565b6040518563ffffffff1660e01b8152600401610ab89493929190615315565b60206040518083038186803b158015610ad057600080fd5b505af4158015610ae4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b089190614aeb565b9392505050565b600060648310801590610b235750600d5483105b80610b4357506004546001600160a01b031633148015610b435750606483105b610b745760405162461bcd60e51b81526020600482015260026024820152610ac760f31b60448201526064016109ee565b6000610b7f83613d61565b604051631e598ee360e01b815290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__90631e598ee390610bc390600590899089908890600401615315565b60206040518083038186803b158015610bdb57600080fd5b505af4158015610bef573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c139190614aeb565b90506001600160801b03811615610dcc576064851015610cbb576006546004805460405163a9059cbb60e01b81526001600160a01b039384169363a9059cbb93610c6393909116918691016150b2565b602060405180830381600087803b158015610c7d57600080fd5b505af1158015610c91573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cb591906149d0565b50610dcc565b60065460405163bf22e33d60e01b815260056004820152602481018790526001600160a01b039091169063a9059cbb9073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b158015610d2257600080fd5b505af4158015610d36573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d5a91906145e8565b836040518363ffffffff1660e01b8152600401610d789291906150b2565b602060405180830381600087803b158015610d9257600080fd5b505af1158015610da6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dca91906149d0565b505b604080518681526001600160801b038316602082015285917f577d7c566c3ee0cdd87eb845364af22c23e3f12677618fc33e3596c07c78f090910160405180910390a2949350505050565b606060028054610e2690615484565b80601f0160208091040260200160405190810160405280929190818152602001828054610e5290615484565b8015610e9f5780601f10610e7457610100808354040283529160200191610e9f565b820191906000526020600020905b815481529060010190602001808311610e8257829003601f168201915b50505050509050919050565b60405163bf22e33d60e01b81526005600482015260248101859052849073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b158015610eff57600080fd5b505af4158015610f13573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f3791906145e8565b6001600160a01b0316336001600160a01b0316148015610f58575060648110155b8015610f655750600d5481105b80610f8557506004546001600160a01b031633148015610f855750606481105b610fa15760405162461bcd60e51b81526004016109ee906151e3565b6000836001600160801b031611610fca5760405162461bcd60e51b81526004016109ee906152aa565b6000610fd4613cd8565b60405163601884ab60e11b815290915073__$03106d4e1898139463e4ca6f62fde1e69e$__9063c031095690611017906005908a908a908a908890600401615374565b60006040518083038186803b15801561102f57600080fd5b505af4158015611043573d6000803e3d6000fd5b5050505061106b8386866001600160801b031660405180602001604052806000815250613e41565b857f8f7669a65de5bf9fc879f40cf52d384b8714be267b837bae1e7ba7a402ffae6486868660405161109f939291906153e2565b60405180910390a2505050505050565b6000806110ba613cd8565b60405163cf0e577b60e01b815290915073__$03106d4e1898139463e4ca6f62fde1e69e$__9063cf0e577b906110fd906005908990899087908a90600401615339565b60206040518083038186803b15801561111557600080fd5b505af4158015611129573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061114d9190614aeb565b95945050505050565b6004546001600160a01b031633146111955760405162461bcd60e51b8152602060048201526002602482015261563560f01b60448201526064016109ee565b604051634c152c3760e01b815260056004820152602481018390526001600160801b038216604482015273__$03106d4e1898139463e4ca6f62fde1e69e$__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__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b15801561166f57600080fd5b505af4158015611683573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116a791906145e8565b6001600160a01b0316336001600160a01b03161480156116c8575060648110155b80156116d55750600d5481105b806116f557506004546001600160a01b0316331480156116f55750606481105b6117115760405162461bcd60e51b81526004016109ee906151e3565b826001600160801b031660001080156117365750620f4240836001600160801b031611155b6117675760405162461bcd60e51b81526020600482015260026024820152612b1b60f11b60448201526064016109ee565b6001600160801b0384161561186757836001600160801b031661178a3387610986565b10156117a85760405162461bcd60e51b81526004016109ee906151c7565b604051630d10a83160e01b815273__$03106d4e1898139463e4ca6f62fde1e69e$__90630d10a831906117e6906005908a908a908a90600401615315565b60006040518083038186803b1580156117fe57600080fd5b505af4158015611812573d6000803e3d6000fd5b5050505061182a3386866001600160801b03166140ad565b857f1b1208c3b4aabf85636986188bb1f61e1cd5ab23c217e6d66ce0f24cb28a7e8686863360405161185e939291906153e2565b60405180910390a25b6000858152600b602052604081206001015460648810916001600160801b039091169073__$03106d4e1898139463e4ca6f62fde1e69e$__631ca55d3160058b856118b0613cd8565b6040516001600160e01b031960e087901b1681526004810194909452602484019290925260448301526001600160801b0390811660648301528916608482015285151560a482015260c40160206040518083038186803b15801561191357600080fd5b505af4158015611927573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061194b9190614aeb565b90506001600160801b03811615611a255760065460405163a9059cbb60e01b81526001600160a01b039091169063a9059cbb9061198e90339085906004016150b2565b602060405180830381600087803b1580156119a857600080fd5b505af11580156119bc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119e091906149d0565b50604080518381526001600160801b03831660208201528a917f3ca1aaf13f818ea7cb96d12c7d65ff647c1236b703b5d59859992cc7862e68df910160405180910390a25b98975050505050505050565b826064811015611a685760405162461bcd60e51b8152602060048201526002602482015261563360f01b60448201526064016109ee565b6000826001600160801b031611611a915760405162461bcd60e51b81526004016109ee906152aa565b816001600160801b0316611aa53385610986565b1015611ac35760405162461bcd60e51b81526004016109ee906151c7565b6000611acd613cd8565b60405163da25cb5b60e01b815290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__9063da25cb5b90611b13906005908a908a908a908990600401615374565b60206040518083038186803b158015611b2b57600080fd5b505af4158015611b3f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b639190614aeb565b60065460405163a9059cbb60e01b81529192506001600160a01b03169063a9059cbb90611b9690339085906004016150b2565b602060405180830381600087803b158015611bb057600080fd5b505af1158015611bc4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611be891906149d0565b50611bfd3386866001600160801b03166140ad565b60408051878152602081018790527fa7c1efbe8c264edbfd86d7edf1a6b82896995680f966de445fc3b6e0531bf41a910160405180910390a1505050505050565b60405163bf22e33d60e01b81526005600482015260248101849052839073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b158015611c9257600080fd5b505af4158015611ca6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611cca91906145e8565b6001600160a01b0316336001600160a01b0316148015611ceb575060648110155b8015611cf85750600d5481105b80611d1857506004546001600160a01b031633148015611d185750606481105b611d345760405162461bcd60e51b81526004016109ee906151e3565b6000826001600160801b031611611d5d5760405162461bcd60e51b81526004016109ee906152aa565b60405163fda0f8d760e01b815273__$03106d4e1898139463e4ca6f62fde1e69e$__9063fda0f8d790611d9b90600590889088908890600401615315565b60006040518083038186803b158015611db357600080fd5b505af4158015611dc7573d6000803e3d6000fd5b50506006546040516323b872dd60e01b81526001600160a01b0390911692506323b872dd9150611dff90339030908790600401615041565b602060405180830381600087803b158015611e1957600080fd5b505af1158015611e2d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e5191906149d0565b50604080518481526001600160801b038416602082015285917fadd97c0a46c3609a18f63db5242b635f4cef8e7569c39a94549634b4ddca756591015b60405180910390a250505050565b600073__$03106d4e1898139463e4ca6f62fde1e69e$__6382794c08600584611ec3613cd8565b6040516001600160e01b031960e086901b168152600481019390935260248301919091526001600160801b0316604482015260640160206040518083038186803b158015611f1057600080fd5b505af4158015611f24573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a699190614aeb565b60608151835114611fad5760405162461bcd60e51b815260206004820152602960248201527f455243313135353a206163636f756e747320616e6420696473206c656e677468604482015268040dad2e6dac2e8c6d60bb1b60648201526084016109ee565b600083516001600160401b03811115611fd657634e487b7160e01b600052604160045260246000fd5b604051908082528060200260200182016040528015611fff578160200160208202803683370190505b50905060005b84518110156120a15761206685828151811061203157634e487b7160e01b600052603260045260246000fd5b602002602001015185838151811061205957634e487b7160e01b600052603260045260246000fd5b6020026020010151610986565b82828151811061208657634e487b7160e01b600052603260045260246000fd5b602090810291909101015261209a816154eb565b9050612005565b509392505050565b60405163fc74e4b760e01b81526005600482015260609073__$03106d4e1898139463e4ca6f62fde1e69e$__9063fc74e4b79060240160006040518083038186803b1580156120f757600080fd5b505af415801561210b573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052612133919081019061486d565b90505b90565b600854600090600a90829061216090600190600160801b90046001600160801b0316615445565b6001600160801b03168152602081019190915260400160002054600160801b90046001600160401b0316919050565b60405163bf22e33d60e01b81526005600482015260248101859052849073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b1580156121e357600080fd5b505af41580156121f7573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061221b91906145e8565b6001600160a01b0316336001600160a01b031614801561223c575060648110155b80156122495750600d5481105b8061226957506004546001600160a01b0316331480156122695750606481105b6122855760405162461bcd60e51b81526004016109ee906151e3565b6000826001600160801b0316116122ae5760405162461bcd60e51b81526004016109ee906152aa565b6040516311fce20160e21b8152600560048201526024810186905260448101859052606481018490526001600160801b038316608482015260009073__$03106d4e1898139463e4ca6f62fde1e69e$__906347f388049060a40160206040518083038186803b15801561232057600080fd5b505af4158015612334573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123589190614aeb565b9050806001600160801b031661236e3386610986565b101561120b5760405162461bcd60e51b815260206004820152600360248201526205631360ec1b60448201526064016109ee565b60405163bf22e33d60e01b81526005600482015260248101869052600090869073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b1580156123f957600080fd5b505af415801561240d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061243191906145e8565b6001600160a01b0316336001600160a01b0316148015612452575060648110155b801561245f5750600d5481105b8061247f57506004546001600160a01b03163314801561247f5750606481105b61249b5760405162461bcd60e51b81526004016109ee906151e3565b6000846001600160801b0316116124c45760405162461bcd60e51b81526004016109ee906152aa565b846001600160801b031660001080156124e95750620f4240856001600160801b031611155b61251a5760405162461bcd60e51b81526020600482015260026024820152612b1b60f11b60448201526064016109ee565b6064871060008073__$03106d4e1898139463e4ca6f62fde1e69e$__632cff0a8c60058c8c8b8d612549613cd8565b6040516001600160e01b031960e089901b1681526004810196909652602486019490945260448501929092526001600160801b03908116606485015290811660848401521660a482015285151560c482015260e401604080518083038186803b1580156125b557600080fd5b505af41580156125c9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125ed9190614bd7565b6006546040516323b872dd60e01b81529294509092506001600160a01b0316906323b872dd9061262590339030908690600401615041565b602060405180830381600087803b15801561263f57600080fd5b505af1158015612653573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061267791906149d0565b5061269c868a896001600160801b031660405180602001604052806000815250613e41565b604080518381526001600160801b03831660208201528b917fadd97c0a46c3609a18f63db5242b635f4cef8e7569c39a94549634b4ddca7565910160405180910390a2897f8f7669a65de5bf9fc879f40cf52d384b8714be267b837bae1e7ba7a402ffae648a8989604051612713939291906153e2565b60405180910390a29998505050505050505050565b60405163b731e01f60e01b8152600560048201526024810183905260448101829052600090819073__$03106d4e1898139463e4ca6f62fde1e69e$__9063b731e01f90606401604080518083038186803b15801561278557600080fd5b505af4158015612799573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906127bd9190614b07565b915091509250929050565b6040516354a1bf7960e01b815260056004820152336024820152600090819073__$03106d4e1898139463e4ca6f62fde1e69e$__906354a1bf799060440160206040518083038186803b15801561281e57600080fd5b505af4158015612832573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128569190614a24565b60405181815290915033907f487f75407abee1a719a204e683a93f0583efee10816d2651b112f8be571f7d329060200160405180910390a2905090565b604080516060808201835260008083526020830152918101919091526000828152600a6020908152604091829020825160608101845281546001600160801b0381168252600160801b90046001600160401b0316818401526001820180548551818602810186018752818152929593949386019383018282801561293657602002820191906000526020600020905b815481526020019060010190808311612922575b5050505050815250509050919050565b336001600160a01b03831614156129b15760405162461bcd60e51b815260206004820152602960248201527f455243313135353a2073657474696e6720617070726f76616c20737461747573604482015268103337b91039b2b63360b91b60648201526084016109ee565b3360008181526001602090815260408083206001600160a01b0387168085529252909120805460ff1916841515179055906001600160a01b03167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c3183604051612a1e911515815260200190565b60405180910390a35050565b63ffffffff841660648110612a665760405162461bcd60e51b81526020600482015260026024820152612b1960f11b60448201526064016109ee565b6000612a70613cd8565b6040516334f2839360e01b81526005600482015263ffffffff88166024820152604481018790526001600160801b038216606482015290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__906334f283939060840160206040518083038186803b158015612ae357600080fd5b505af4158015612af7573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b1b9190614a24565b6040516322ce535960e11b815290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__9063459ca6b290612b65906005908c908c90899089908e908e906004016153a3565b60206040518083038186803b158015612b7d57600080fd5b505af4158015612b91573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612bb59190614a24565b6040805163ffffffff8b168152602081018590529081018290529091507f87b9ffa523a6e912c82ab52430234fcbce63dceb96e713edf6730b524214fcc69060600160405180910390a15050505050505050565b6040805160e081018252600080825260208201819052818301819052606082018190526080820181905260a0820181905260c08201529051633f26b36f60e01b8152600560048201526024810183905273__$03106d4e1898139463e4ca6f62fde1e69e$__90633f26b36f9060440160e06040518083038186803b158015612c9057600080fd5b505af4158015612ca4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a699190614a3c565b6004546001600160a01b031615612cde57600080fd5b600480546001600160a01b0319166001600160a01b038381169190911791829055612d0b91166001612946565b50565b60405163bf22e33d60e01b81526005600482015260248101859052849073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b158015612d6257600080fd5b505af4158015612d76573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612d9a91906145e8565b6001600160a01b0316336001600160a01b0316148015612dbb575060648110155b8015612dc85750600d5481105b80612de857506004546001600160a01b031633148015612de85750606481105b612e045760405162461bcd60e51b81526004016109ee906151e3565b6000826001600160801b031611612e2d5760405162461bcd60e51b81526004016109ee906152aa565b6040516344404e9160e11b8152600560048201526024810186905260448101859052606481018490526001600160801b038316608482015273__$03106d4e1898139463e4ca6f62fde1e69e$__906388809d229060a40160006040518083038186803b158015612e9c57600080fd5b505af4158015612eb0573d6000803e3d6000fd5b505050505050505050565b6000838152600b60209081526040808320815160808101835281546001600160401b03808216835260ff680100000000000000008304161515958301959095526901000000000000000000900490931691830191909152600101546001600160801b03166060820181905273__$03106d4e1898139463e4ca6f62fde1e69e$__9063d3cf062c9060059088612f4e613cd8565b89896040518763ffffffff1660e01b81526004016110fd969594939291906152d9565b6000828152600b602052604081206001600160801b038316612f933386610986565b1015612fb15760405162461bcd60e51b81526004016109ee906151c7565b6001810154600090612fcb906001600160801b0316613d61565b6040516389ea005560e01b815260056004820152602481018790526001600160801b0380871660448301528216606482015290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__906389ea00559060840160206040518083038186803b15801561303a57600080fd5b505af415801561304e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906130729190614aeb565b90506130883387876001600160801b03166140ad565b60065460405163a9059cbb60e01b81526001600160a01b039091169063a9059cbb906130ba90339085906004016150b2565b602060405180830381600087803b1580156130d457600080fd5b505af11580156130e8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061310c91906149d0565b50604080516001600160801b0380881682528316602082015287917f18573accbcbb8a86bbee146d4e50e8aac82207f309375b697377830f81a481e9910160405180910390a295945050505050565b6003546001600160a01b031633146131855760405162461bcd60e51b81526004016109ee9061528e565b73__$03106d4e1898139463e4ca6f62fde1e69e$__631e6149e26005836131aa613cd8565b33600460009054906101000a90046001600160a01b03166001600160a01b031663ae2e933b6040518163ffffffff1660e01b8152600401602060405180830381600087803b1580156131fb57600080fd5b505af115801561320f573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061323391906145e8565b6040516001600160e01b031960e088901b16815260048101959095526001600160801b0393841660248601529290911660448401526001600160a01b03908116606484015216608482015260a40160006040518083038186803b15801561329957600080fd5b505af41580156132ad573d6000803e3d6000fd5b5050505050565b6003546001600160a01b031633146132de5760405162461bcd60e51b81526004016109ee9061528e565b6040516352ebbeab60e01b8152600560048201526001600160401b038416602482015260009073__$03106d4e1898139463e4ca6f62fde1e69e$__906352ebbeab9060440160206040518083038186803b15801561333b57600080fd5b505af415801561334f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133739190614aeb565b905060005b835181101561343c576133dc828583815181106133a557634e487b7160e01b600052603260045260246000fd5b602002602001015160008685815181106133cf57634e487b7160e01b600052603260045260246000fd5b602002602001015161422f565b61342a8285838151811061340057634e487b7160e01b600052603260045260246000fd5b602002602001015160018685815181106133cf57634e487b7160e01b600052603260045260246000fd5b80613434816154eb565b915050613378565b506040516001600160401b03851681526001600160801b038216907f237e506b7aca39c784d20df2367724c8435ddf108c90403b76eefc08194ce2e090602001611e8e565b60405163bf22e33d60e01b81526005600482015260248101849052839073__$03106d4e1898139463e4ca6f62fde1e69e$__9063bf22e33d9060440160206040518083038186803b1580156134d557600080fd5b505af41580156134e9573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061350d91906145e8565b6001600160a01b0316336001600160a01b031614801561352e575060648110155b801561353b5750600d5481105b8061355b57506004546001600160a01b03163314801561355b5750606481105b6135775760405162461bcd60e51b81526004016109ee906151e3565b6000826001600160801b0316116135a05760405162461bcd60e51b81526004016109ee906152aa565b60006135aa613cd8565b604051631f51db6b60e21b815290915073__$03106d4e1898139463e4ca6f62fde1e69e$__90637d476dac906135ed906005908990899089908890600401615374565b60006040518083038186803b15801561360557600080fd5b505af4158015613619573d6000803e3d6000fd5b505060065460405163a9059cbb60e01b81526001600160a01b03909116925063a9059cbb915061364f90339087906004016150b2565b602060405180830381600087803b15801561366957600080fd5b505af115801561367d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906136a191906149d0565b50604080518581526001600160801b038516602082015286917f3ca1aaf13f818ea7cb96d12c7d65ff647c1236b703b5d59859992cc7862e68df91015b60405180910390a25050505050565b600c805482919060009061370b9084906001600160801b0316615445565b82546001600160801b039182166101009390930a9283029190920219909116179055506006546040516323b872dd60e01b81526001600160a01b03909116906323b872dd9061376290339030908690600401615041565b602060405180830381600087803b15801561377c57600080fd5b505af1158015613790573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906137b491906149d0565b5050565b600073__$03106d4e1898139463e4ca6f62fde1e69e$__6334f28393600585856137e0613cd8565b6040518563ffffffff1660e01b81526004016137ff9493929190615315565b60206040518083038186803b15801561381757600080fd5b505af415801561382b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b089190614a24565b63ffffffff84166064811061388b5760405162461bcd60e51b81526020600482015260026024820152612b1960f11b60448201526064016109ee565b6000613895613cd8565b6040516334f2839360e01b81526005600482015263ffffffff88166024820152604481018790526001600160801b038216606482015290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__906334f283939060840160206040518083038186803b15801561390857600080fd5b505af415801561391c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906139409190614a24565b604051630287019560e31b815290915060009073__$03106d4e1898139463e4ca6f62fde1e69e$__906314380ca890612b65906005908c908c90899089908e908e906004016153a3565b600073__$03106d4e1898139463e4ca6f62fde1e69e$__63c265d8d4600585856139b2613cd8565b6040516001600160e01b031960e087901b1681526004810194909452602484019290925260448301526001600160801b031660648201526000608482015260a401610ab8565b6001600160a01b03808316600090815260016020908152604080832093851683529290529081205460ff1680613a3657506001600160a01b03821630145b80610b085750506004546001600160a01b03908116911614919050565b6001600160a01b038416613a795760405162461bcd60e51b81526004016109ee906151ff565b6001600160a01b038516331480613a955750613a9585336108e4565b613af35760405162461bcd60e51b815260206004820152602960248201527f455243313135353a2063616c6c6572206973206e6f74206f776e6572206e6f7260448201526808185c1c1c9bdd995960ba1b60648201526084016109ee565b33613b0c818787613b038861433b565b6132ad8861433b565b6000848152602081815260408083206001600160a01b038a16845290915290205483811015613b4d5760405162461bcd60e51b81526004016109ee90615244565b613b57848261546d565b6000868152602081815260408083206001600160a01b038c81168552925280832093909355881681529081208054869290613b9390849061542d565b909155505060408051868152602081018690526001600160a01b03808916928a821692918616917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4613bf3828888888888614394565b50505050505050565b6003546001600160a01b03163314613c265760405162461bcd60e51b81526004016109ee9061528e565b6000816001600160801b031611613c3c57600080fd5b604051630e8c6a9360e31b81526005600482015260ff831660248201526001600160801b038216604482015273__$03106d4e1898139463e4ca6f62fde1e69e$__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__$03106d4e1898139463e4ca6f62fde1e69e$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'

export interface OptionVaultLibraryAddresses {
  ['__$03106d4e1898139463e4ca6f62fde1e69e$__']: string
}
